import { updateScrollCache } from '@/components/helpers/collection'
import { updateViewedProducts } from '@/components/helpers/product'

function handleProductLoad() {
  if (typeof productSku === 'undefined') return
  updateViewedProducts(productSku)

  if (typeof productHandle === 'undefined') return
  const params = new URLSearchParams(window.location.search)

  if (!params.has('from')) return

  const collectionHandle = params.get('from')
  updateScrollCache(collectionHandle, productHandle)
}

handleProductLoad()
